@if (data) {
  @if (breadcrumbsComponent) {
    <dotcom-frontend-loader [componentData]="breadcrumbsComponent" />
  }

  @if (disclaimerComponent) {
    <dotcom-frontend-loader [componentData]="disclaimerComponent" />
  }

  @for (item of data["headerBanner"]; let i = $index; track i) {
    <dotcom-frontend-loader
      [componentData]="item"
      parent="headerBanner"
      parentSpacing="zero"
    />
  }

  @for (item of data["disclaimerPopup"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" />
  }

  @if (trustPilotBarComponent) {
    <dotcom-frontend-loader [componentData]="trustPilotBarComponent" />
  }

  @if (data["pageTitle"] && data["heroContentArea"].length === 0) {
    <div lgContainer>
      <h1
        class="page-title lg-font--expressive lg-font-size-7 lg-font-size-7--medium"
      >
        {{ data["pageTitle"] }}
      </h1>
    </div>
  }

  @for (item of data["heroContentArea"]; let i = $index; track i) {
    <dotcom-frontend-loader
      [componentData]="item"
      [ngClass]="{ 'in-page-nav__hero-spacing': isInPageNavigationSet }"
    />
  }

  @if (
    isInPageNavigationSet && navItems && navItems.length && inPageNavComponent
  ) {
    <dotcom-frontend-loader [componentData]="inPageNavComponent" />
  }

  @if (byLineComponent) {
    <div lgContainer>
      <dotcom-frontend-loader [componentData]="byLineComponent" />
    </div>
  }

  <div lgContainer>
    @for (item of data["mainContentArea"]; let i = $index; track i) {
      <dotcom-frontend-loader [componentData]="item" contentLayout="full" />
    }

    @if (blogList) {
      @if (ifCommunities) {
        <div lgRow>
          <div [lgColSm]="12" [lgColLg]="6">
            <div class="sortby-community-dropdown">
              <lg-select-field>
                <label>Personalise your homepage</label>
                <select
                  lgSelect
                  #selectOption
                  id="filterBy"
                  [(ngModel)]="filterOption"
                  class="lg-select-field__inputs"
                  aria-label="Filter by dropdown"
                  (change)="applyFilters($event)"
                >
                  <option value="0">Show everything</option>
                  @if (communityGroups) {
                    @for (group of communityGroups; let i = $index; track i) {
                      <optgroup label="{{ group.group }}">
                        {{ group.group }}
                        @for (
                          option of group.communityGroups;
                          let i = $index;
                          track i
                        ) {
                          <option value="{{ option.id }}">
                            {{ option.name }}
                          </option>
                        }
                      </optgroup>
                    }
                  }
                </select>
              </lg-select-field>
            </div>
          </div>
        </div>
      }

      <div lgRow>
        @for (blog of blogList; let i = $index; track i) {
          <div
            [lgColLg]="getColSpan(i + 1)"
            [lgColMd]="getColSpan(i + 1)"
            [lgColSm]="12"
          >
            <dotcom-frontend-loader [componentData]="blog" />
          </div>
        }
      </div>

      @if (showSpinner) {
        <div [lgColLg]="12" [lgColMd]="12" [lgColSm]="12">
          <lg-spinner></lg-spinner>
        </div>
      }

      @if (showLoadMore) {
        <div [lgColSm]="12">
          <button
            (click)="
              loadBlogList(indexPageId, page + 1, filterOption);
              interactionClickEvent('/', 'Load more articles')
            "
            lg-button
            type="button"
            variant="primary-dark"
          >
            Load more
          </button>
        </div>
      }
    }
  </div>

  @for (item of data["lowerScreenStickyBanner"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" />
  }
}
